import React, { Component } from "react";
import { connect } from "react-redux";
import M from "materialize-css/dist/js/materialize.min.js";
import Assets from "./Assets";
import Transfers from "./Transfers";
import History from "./History";
import Terms from './terms';
import "./passport.css";
import Start from "./Upload";
import Modal from "../helper/modal";
import {updateSettings} from "../../actions/ui/settings";
import {isMobile} from 'react-device-detect';

class Home extends Component {
  constructor(){
    super()
    this.state = {view:'assets'};
  }
  openTerms(){
    if (!this.props.settings.terms) {
      const modalElement = M.Modal.getInstance(document.querySelector("#termsModal"));
      modalElement.open();
    }
  }
  componentDidMount() {
    this.openTerms()
  }
  componentDidUpdate(){
    this.openTerms()
  }
  closeTerms() {
    const modalElement = M.Modal.getInstance(document.querySelector("#termsModal"));
    modalElement.close();
    let settings = this.props.settings;
    settings.terms = true;
    this.props.updateSettings(settings,()=>{})
  }
  setView(view) {
    this.setState({ view });
  }
  renderMobile(){
    let mnemStyle = this.state.view === "assets" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};
    let jsonStyle = this.state.view === "transfer" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px' };
    let privStyle = this.state.view === "history" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};

    return (
      <div clasName='col s12' style={{height:'50px',marginTop:'10px'}}>
        <div className="col s4">
          <div onClick={this.setView.bind(this, "assets")} className='B' style={{cursor:'pointer',border:this.state.view === "assets" ? '1px solid white':'1px solid grey'}}>
            <h5 style={mnemStyle}> assets </h5>
          </div>
        </div>
        <div className="col s4">
          <div onClick={this.setView.bind(this, "transfer")} className='C' style={{cursor:'pointer',border:this.state.view === "transfer" ? '1px solid white':'1px solid grey'}}>
            <h5 style={jsonStyle}> transfer </h5>
          </div>
        </div>
        <div className="col s4">
          <div onClick={this.setView.bind(this, "history")} className='D' style={{cursor:'pointer',border:this.state.view === "history" ? '1px solid white':'1px solid grey'}}>
            <h5 style={privStyle}> history </h5>
          </div>
        </div>
      </div>
    )
  }
  render() {
    let modal = (<Modal id="termsModal" noClose={true} noIcon={true} classes="modal modalOrder modal-fixed-footer" title="Terms and Conditions" component={(<Terms/>)} buttonAction={this.closeTerms.bind(this)} buttonText="I agree"/>);

    if (this.props.loggedIn !== undefined && this.props.loggedIn !== false) {
      return (
        <div className="row" style={{marginTop:isMobile ? '10px': '20px'}}>
          <div id="passport" className="minWidth container row passportDiv" style={{paddingBottom:'20px',height:'600px',border: isMobile ? 'none' : '1px solid grey'}}>
            {isMobile && this.renderMobile()}
            {(isMobile && this.state.view === 'assets') || !isMobile ? <Assets /> : null}
            <div className="col s12 m10" style={{ padding: 0 }}>
            {(isMobile && this.state.view === 'transfer') || !isMobile ? <Transfers /> : null}
            {(isMobile && this.state.view === 'history') || !isMobile ? <History /> : null}
            </div>
          </div>
          {modal}
        </div>
      );
    } else {
      return (
        <div>
          <Start />
          {modal}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    settings: state.settings.settings,
    loggedIn:
      state.passport.wallet.emb &&
      state.passport.wallet.nrg &&
      state.passport.wallet["l-emb"] &&
      Object.keys(state.passport.wallet.emb).length > 0,
  };
}

export default connect(mapStateToProps, {updateSettings})(Home);
